module.exports = "fragment UserImageFragment on Image {\n  __typename\n  ...ImageFragment\n  createdAt\n}\n"